import { VariableKindPrefix } from '../variables.model'

export function isEditorVariable(variableId: string) {
  return (
    variableId.startsWith(VariableKindPrefix.OBSERVATIONS) ||
    variableId.startsWith(VariableKindPrefix.NOTE)
  )
}
